module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "toc-head"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/xhtml/cover",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cover")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/xhtml/alsoby"
    }
  }, [_vm._v("Recent titles by John Farrow")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/xhtml/title"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/xhtml/copyright"
    }
  }, [_vm._v("Copyright")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text-space-after"
  }, [_c('a', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/xhtml/dedication"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/xhtml/part001"
    }
  }, [_vm._v("Part One: 1975")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text-indented"
  }, [_c('a', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/xhtml/chapter001"
    }
  }, [_vm._v("A Special Joy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text-indented"
  }, [_c('a', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/xhtml/chapter002"
    }
  }, [_vm._v("The Gum Machine")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text-indented"
  }, [_c('a', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/xhtml/chapter003"
    }
  }, [_vm._v("Whisky Spree")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text-indented"
  }, [_c('a', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/xhtml/chapter004"
    }
  }, [_vm._v("The Getaway Boy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text-indented"
  }, [_c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/xhtml/chapter005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("On the Job")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text-indented"
  }, [_c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/xhtml/chapter006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The 80")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text-indented"
  }, [_c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/xhtml/chapter007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Royals’ Ball")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text-indented"
  }, [_c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/xhtml/chapter008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("His Last Tiny Marble")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text-indented"
  }, [_c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/xhtml/chapter009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Forty, On a Scale of Ten")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text-indented"
  }, [_c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/xhtml/chapter010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Clunker Free")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text-indented"
  }, [_c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/xhtml/chapter011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Paying for the Mercy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text-indented"
  }, [_c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/xhtml/chapter012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ezra’s Visitor")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text-indented"
  }, [_c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/xhtml/chapter013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Smashing Bones")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text-indented"
  }, [_c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/xhtml/chapter014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Confetti Money")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text-indented"
  }, [_c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/xhtml/chapter015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Homicide Won’t Know")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text-indented-space-after"
  }, [_c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/xhtml/chapter016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Synchronicity of Events")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/xhtml/part002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Two: The Ball")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text-indented"
  }, [_c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/xhtml/chapter017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Red Ants and a Silver Bullet")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text-indented"
  }, [_c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/xhtml/chapter018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Painted Big Toe")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text-indented"
  }, [_c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/xhtml/chapter019",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jars of Honey and the Lurid Carcasses")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text-indented"
  }, [_c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/xhtml/chapter020",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Russian Rabbit")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text-indented"
  }, [_c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/xhtml/chapter021",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mother-of-Pearl Inlay")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text-indented"
  }, [_c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/xhtml/chapter022",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nun Stories")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text-indented"
  }, [_c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/xhtml/chapter023",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Plant 59")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text-indented"
  }, [_c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/xhtml/chapter024",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sacrificial Zinc")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text-indented"
  }, [_c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/xhtml/chapter025",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Raising Horses")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text-indented-space-after"
  }, [_c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/xhtml/chapter026",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Missing Werewolves")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/xhtml/part003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Three: The Park")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text-indented"
  }, [_c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/xhtml/chapter027",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tombstone Ghost")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text-indented"
  }, [_c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/xhtml/chapter028",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mother Love")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text-indented"
  }, [_c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/xhtml/chapter029",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Money Jar")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text-indented"
  }, [_c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/xhtml/chapter030",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Prodigal Mouse")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text-indented"
  }, [_c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/xhtml/chapter031",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dieppe Revisited")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text-indented"
  }, [_c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/xhtml/chapter032",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Airwaves")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text-indented"
  }, [_c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/xhtml/chapter033",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tumblers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text-indented"
  }, [_c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/xhtml/chapter034",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Role")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text-indented"
  }, [_c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/xhtml/chapter035",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Otto’s Pitch")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-218d4410","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 57
// module chunks = 0